<script setup lang="ts">
const props = defineProps<{ mobile?: boolean, path: string[] }>()

const loginPageUrl = useLoginPageUrl()
const products = useProductVariantsStore()
const route = useRoute()

const isProfilePageActive = computed(() =>
  route.path.includes("min-side"),
)

const urlPrefix = computed(() => `/produkter/${props.path.filter(Boolean).join("/")}`)

const { isAuthorized } = useAuth()
</script>

<template>
  <div
    class="flex"
    :class="{
      'w-full  items-center justify-end pt-12 xl:pt-14 <md:!hidden':
        !mobile,
    }"
  >
    <UButton
      v-if="isAuthorized"
      id="min-side"
      data-pendo="min-side-desktop"
      :to="
        isProfilePageActive
          ? `${urlPrefix}${route.hash}`
          : `${urlPrefix}/min-side${route.hash}`
      "
      theme="light"
      size="sm"
      :stacked="mobile"
      :active="isProfilePageActive && !mobile"
    >
      <template #prepend>
        <UIcon
          name="user"
          :class="{ 'mb-2': mobile }"
          :size="mobile ? 'lg' : 'sm'"
        />
      </template>
      Min side
    </UButton>
    <UButton
      v-else-if="loginPageUrl"
      id="logg-in"
      variant="outline"
      :class="{ 'mt-3 <md:!hidden': !mobile }"
      theme="light"
      size="sm"
      :stacked="mobile"
      :to="
        products.activeVariant
          ? `${loginPageUrl}?fromPath=${encodeURIComponent(route.fullPath)}`
          : loginPageUrl
      "
    >
      <template #prepend>
        <UIcon
          name="user"
          :class="{ 'mb-2': mobile }"
          :size="mobile ? 'lg' : 'sm'"
        />
      </template>
      Logg inn
    </UButton>
  </div>
</template>
